<template>
    <el-row :gutter="50" style="padding-bottom: 20px;">
        <el-col :sm="10">
            <v-chart ref="barchart" key="chart" :option="groupBarChartData" style="width: 100%" :style="{ height: '185px' }" autoresize />
        </el-col>
        <el-col :sm="14">
            <el-table :data="data" style="width: 100%" class="projects-statistic-table ah-el-data-table" v-loading="isLoading" empty-text="沒有資料" show-summary :summary-method="getSummaries">
                <el-table-column prop="startYear" label="專案開始年份" width="120" />
                <el-table-column prop="projectCount" label="專案數" align="right" width="70" />
                <el-table-column prop="totalAmountTwd" label="年度專案總金額" align="right">
                    <template slot-scope="scope">
                        <Money :v="scope.row.totalAmountTwd" round />
                        <div class="percentage">100%</div>
                    </template>
                </el-table-column>
                <el-table-column prop="creditedAmountTwd" align="right">
                    <template slot="header">
                        <div class="projects-statistic-table-label-block">
                            <div class="square-block green" />
                            <div>已開發票總額</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <Money :v="scope.row.creditedAmountTwd" round />
                        <div v-if="!!scope.row.totalAmountTwd" class="percentage">{{ Math.round((scope.row.creditedAmountTwd / scope.row.totalAmountTwd) * 100) }}%</div>
                        <div v-else class="percentage">--</div>
                    </template>
                </el-table-column>
                <el-table-column prop="toBeCreditedAmountTwd" align="right">
                    <template slot="header">
                        <div class="projects-statistic-table-label-block">
                            <div class="square-block yellow" />
                            <div>未開發票總額</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <Money :v="scope.row.toBeCreditedAmountTwd" round />
                        <div v-if="!!scope.row.totalAmountTwd" class="percentage">{{ Math.round((scope.row.toBeCreditedAmountTwd / scope.row.totalAmountTwd) * 100) }}%</div>
                        <div v-else class="percentage">--</div>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
    </el-row>
</template>

<script>
import _ from 'lodash';
import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent,
} from 'echarts/components';

use([CanvasRenderer, TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent]);

export default {
    props: {
        isLoading: Boolean,
        data: {
            type: Array,
            default: () => [],
        },
    },
    components: { VChart },
    data() {
        return {
            groupBarChartData: {
                backgroundColor: 'transparent',
                textStyle: { color: '#fff' },
                legend: { textStyle: { color: '#fff', fontSize: 15 } },
                tooltip: { trigger: 'axis' },
                color: ['#56C500', '#FAC300'],
                xAxis: { data: [], axisLabel: { fontSize: 15 } },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(255,255,255,0.2)',
                            width: 1,
                            type: 'solid',
                        },
                    },
                },
                grid: {
                    bottom: '20px',
                    containLabel: true,
                },
                series: [],
            },
        };
    },
    methods: {
        setChartData() {
            const YEARS = _.map(this.data, 'startYear');
            const ISSUED = _.map(this.data, (o) => Math.round(o.creditedAmountTwd));
            const NON_ISSUED = _.map(this.data, (o) => Math.round(o.toBeCreditedAmountTwd));

            this.groupBarChartData.xAxis.data = YEARS;

            this.groupBarChartData.series = [
                {
                    name: '已開發票',
                    stack: 'total',
                    type: 'bar',
                    barWidth: '20%',
                    data: ISSUED,
                },
                {
                    name: '未開發票',
                    stack: 'total',
                    type: 'bar',
                    barWidth: '20%',
                    data: NON_ISSUED,
                },
            ];
            // this.groupBarChartData.legend.data = ['財務收入', '財務支出'];
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '累計總數';
                    return;
                }
                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => Number.isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!Number.isNaN(value)) {
                            return prev + curr;
                        }
                        return prev;
                    }, 0);
                    sums[index] = Math.round(sums[index]).toLocaleString('en-US');
                } else {
                    sums[index] = 'N/A';
                }
            });

            return sums;
        },
    },
};
</script>
